import { postDenyMatch } from "api/Api"
import { MediaTablet } from "api/const/MediaQuery"
import { LoginType } from "components/types/Context"
import { ModalType, StartupAcceptedMatchType } from "components/types/types"
import useMediaQuery from "hook/useMediaQuery"
import { useContext, useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { AppGeneralContext } from "shared/GeneralContext/GeneralContext"
import { Button, Logo } from "../../atoms"
import { MessageCard } from "../../molecules/MessageCard"
import './MatchRequestMessage.css'


type MatchRequestProps = {
  fromSender: boolean,
  matchId: string,
  id: string
  isOld: boolean
}

export const MatchRequestMessage = ({ fromSender, matchId, id, isOld }: MatchRequestProps) => {
  const {
    messagesList,
    setErrorModal,
    loginType,
    setChatIsOpen,
    setMessagesList
  } = useContext(AppGeneralContext)
  const tablet = useMediaQuery(MediaTablet)
  const navigate = useNavigate()
  const DeclineMatch = () => {
    if (isOld) {
      return
    }

    postDenyMatch({ matchId: matchId }).then((res) => {
      if (!res.isSuccess || !res.response) {
        setErrorModal(res.error)
        return false
      }
      const route = loginType === LoginType.startup ? "start-up" : "corporate"
      return tablet ? navigate(`${route}//profile/messaging`) : setChatIsOpen(false)
    })
  }

  useEffect(()=>{
  },[isOld])
  const AcceptMatch = () => {
    if (isOld) {
      return
    }

    let MessageAccepted = messagesList.map(x => {
      if (x.id === id) {
        return { ...x, acceptedMatch: true }
      }
      return x
    })
    setMessagesList(MessageAccepted)
  }

  return (
    <MessageCard className="" fromSender={false}>
      <div className="d-flex  pt-1 pb-1 align-items-center">
        <Logo colorLogo={"white"} className={"match-logo me-2"} />
        {fromSender ?
          <p className="p-0 m-0 fw-700"> You send a match</p>
          :
          <p className="p-0 m-0 fw-700"> You have a Match</p>
        }
      </div>
      {!fromSender &&
        <>
          <p className="p-0 m-0 pt-2 pb-2 match-info-message">
            By accepting, you will be subject to the costs of your subscription plan as specified in terms and conditions.
          </p>
          <Button disabled={isOld} primary background={"transparent"} borderColor={"white"} color={"white"} text={'DECLINE'} className='w-100 mb-2'
            onClick={() => DeclineMatch()} />
          <Button disabled={isOld} primary background={"white"} borderColor={"white"} color={"Black"} text={'ACCEPT MATCH'} className='w-100 fw-700 '
            onClick={() => AcceptMatch()} />
        </>
      }
    </MessageCard>
  )
}


